
import Vue from 'vue';
import { CvToastNotification } from '@carbon/vue';
export default Vue.extend({
  name: 'Header',
  components: {
    CvToastNotification,
  },
  props: {
    /* Error prop would be used in the future for generic error messages */
    error: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lowContrast: false,
      hideCloseButton: true,
    };
  },
});
